import BaseEntity from '../database/BaseEntity.js';

/**
 * Canal Entity
 * Represents a Canal in the system
 *
 * Built-in fields (auto-generated):
 * - id: Unique identifier
 * - createdAt: Creation timestamp
 * - updatedAt: Last update timestamp
 * - createdBy: Email of user who created the record
 */
class Canal extends BaseEntity {
  static collectionName = 'canals';
  static _schema = JSON.parse("{\"name\":\"Canal\",\"type\":\"object\",\"properties\":{\"nombre\":{\"type\":\"string\",\"description\":\"Nombre del canal\"},\"url_stream\":{\"type\":\"string\",\"description\":\"URL del stream en vivo (m3u8, YouTube embed, etc.)\"},\"descripcion\":{\"type\":\"string\",\"description\":\"Descripción del canal\"},\"categoria\":{\"type\":\"string\",\"enum\":[\"Música\",\"Noticias\",\"Deportes\",\"Entretenimiento\",\"Variedad\"],\"default\":\"Música\",\"description\":\"Categoría del canal\"},\"imagen\":{\"type\":\"string\",\"description\":\"URL de la imagen/logo del canal\"},\"activo\":{\"type\":\"boolean\",\"default\":true,\"description\":\"Si el canal está activo\"},\"orden\":{\"type\":\"number\",\"description\":\"Orden de aparición\"}},\"required\":[\"nombre\",\"url_stream\"]}");
}

export { Canal };
export default Canal;
